module.exports = __webpack_public_path__ + "static/media/Aesir3.4c02f891.png";